import { useEffect } from "react"
import vendorsConfig from "../vendorsConfig";
function Page(props){
    useEffect( ()=> {
        document.title = `${props.title} |  ${vendorsConfig.APP_NAME}`
        window.scrollTo(0,0)
    }, [])
return (
    <>
        {props.children}
    </>
    )
}

export default Page